module.exports = __webpack_public_path__ + "static/media/loading.44686e52.svg";